export default __webpack_public_path__ + "static/media/cave_in_front.01896383.png";